import { useMutation } from "@tanstack/react-query";
import {
  bookingsBulkUpdate,
  BookingsBulkUpdatePayload,
  BulkOperationResponse
} from "PFCore/services/bookings_bulk_operation";

export const useBookingsBulkUpdate = () =>
  useMutation<BulkOperationResponse, unknown, BookingsBulkUpdatePayload>({
    mutationFn: (payload) => bookingsBulkUpdate(payload)
  });
